import Heron1 from '../../../media/Residentials/Heron/Heron.webp'
import Heron2 from '../../../media/Residentials/Heron/Heron  (1).webp'
import Heron3 from '../../../media/Residentials/Heron/Heron  (2).webp'
import Heron4 from '../../../media/Residentials/Heron/Heron  (3).webp'
import Heron5 from '../../../media/Residentials/Heron/Heron  (4).webp'
import Heron6 from '../../../media/Residentials/Heron/Heron  (5).webp'
import Heron7 from '../../../media/Residentials/Heron/Heron  (6).webp'
import Heron8 from '../../../media/Residentials/Heron/Heron  (7).webp'
import Heron9 from '../../../media/Residentials/Heron/Heron  (8).webp'
import Heron10 from '../../../media/Residentials/Heron/Heron  (9).webp'
import Heron11 from '../../../media/Residentials/Heron/Heron  (10).webp'
import Heron12 from '../../../media/Residentials/Heron/Heron  (11).webp'
import Heron13 from '../../../media/Residentials/Heron/Heron  (12).webp'
import Heron14 from '../../../media/Residentials/Heron/Heron  (13).webp'
import Heron15 from '../../../media/Residentials/Heron/Heron  (14).webp'
import Heron16 from '../../../media/Residentials/Heron/Heron  (15).webp'
import Heron17 from '../../../media/Residentials/Heron/Heron  (16).webp'
import Heron18 from '../../../media/Residentials/Heron/Heron  (17).webp'

const Heronimages =[
Heron1,Heron2,Heron3,Heron4,Heron5,Heron6,Heron7,Heron8,Heron9,Heron10,Heron11,Heron12,Heron13,Heron14,Heron15,Heron16,Heron17,Heron18
]

export default Heronimages;